<template>
  <div class="button-filter-main">
    <button :disabled="buttonIsDisabled" :style="{ alignItems: filterAlignment }" @click="buttonClicked">
      <div>{{ buttonText }}</div>
      <div v-if="showFilter" class="filter-section" @mouseenter="mouseInFilter = true" @mouseleave="mouseInFilter = false"
        :style="filterStyling">
        <slot>Slot not implemented</slot>
      </div>
    </button>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      showFilter: false,
      mouseInFilter: false,
    }
  },
  computed: {
    filterAlignment: function() {
      let alignment = 'flex-start';

      switch (this.filterPosition) {
        case 'left':
          alignment = 'flex-start';
          break;
        case 'center':
          alignment = 'center';
          break;
        case 'right':
          alignment = 'flex-end';
          break;
        default:
          console.warn(`ButtonFilter - filterPosition props does not contain ${this.filterPosition} position. Please use left, center or right only. filterPosition is defaulted to left`);
          break;
      }

      return alignment;
    },
    filterStyling: function() {
      return {
        minWidth: this.filterWidth ? `${this.filterWidth}px` : '100%',
        maxWidth: this.filterWidth ? `${this.filterWidth}px` : '100%',
        border: this.hasBorder ? '1px solid gray' : '',
      }
    }
  },
  props: {
    buttonText: { type: String, default: 'Button' },
    buttonIsDisabled: { type: Boolean, default: false },
    filterWidth: { type: Number, default: 200 },
    filterPosition: { type: String, default: 'left' }, // left, center, right
    isOpen: { type: Boolean, default: false },
    hasBorder: { type: Boolean, default: true },
  },
  methods: {
    buttonClicked: function() {
      if (!this.mouseInFilter) {
        this.showFilter = !this.showFilter;
        this.$emit('update:isOpen', this.showFilter);
      }
    }
  },
  mounted() {
    this.showFilter = this.isOpen;
  },
  watch: {
    isOpen: function(val) {
      this.showFilter = val;
    },
    showFilter: function(val) {
      if (!val) {
        setTimeout(() => {
          this.mouseInFilter = false;
        }, 500);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.button-filter-main {
 > button {
   position: relative;
   display: flex;
   flex-direction: column;

   > .filter-close {
     position: absolute;
     width: 100%;
     height: 100%;
     top: 0;
     left: 0;
     display: flex;
     align-items: center;
     justify-content: center;
     font-weight: bold;
   }

   > .filter-section {
     position: absolute;
     z-index: 9999;
     width: 100%;
     top: 100%;
     padding: 5px;
     background-color: white;
     margin: 0 -10px;
     border-radius: 5px;
   }
 }
}
</style>